import { useState } from 'react';
import { api } from '../lib/api';
import { Mail, Send } from 'lucide-react';
import { toast } from 'sonner';
import PageMascots from '../components/PageMascots';

export default function Contacts() {
  const [f, setF] = useState({ name:'', email:'', subject:'', message:'' });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/contacts', f);
      setSent(true);
    } catch (err) { toast.error('Failed'); }
  };
  return (
    <div className="relative max-w-2xl mx-auto px-4 sm:px-6 py-16 overflow-visible">
      <PageMascots />
      <div className="relative z-10">
      <div className="badge-cozy mb-3">💌 Contacts</div>
      <h1 className="text-4xl sm:text-5xl font-heading font-semibold mb-6">Summon us!</h1>
      <div className="magical-card p-4 mb-6 flex items-center gap-3 text-sm">
        <Mail size={16} className="text-[#f97316]"/>
        <a href="mailto:hello@ghostie.it" className="link-soft">hello@ghostie.it</a>
      </div>
      {sent ? (
        <div className="magical-card p-8 text-center">
          <h3 className="font-heading text-2xl mb-2">Message received.</h3>
          <p className="text-[#a3a3a3]">We'll reply soon.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="magical-card p-6 space-y-4">
          <div><label className="label">Name</label><input required className="input-cozy" value={f.name} onChange={e=>setF(s=>({...s,name:e.target.value}))} data-testid="contact-name"/></div>
          <div><label className="label">Email</label><input required type="email" className="input-cozy" value={f.email} onChange={e=>setF(s=>({...s,email:e.target.value}))} data-testid="contact-email"/></div>
          <div><label className="label">Subject</label><input required maxLength={50} className="input-cozy" value={f.subject} onChange={e=>setF(s=>({...s,subject:e.target.value}))} data-testid="contact-subject"/></div>
          <div><label className="label">Message</label><textarea required rows={5} className="input-cozy" value={f.message} onChange={e=>setF(s=>({...s,message:e.target.value}))} data-testid="contact-message"/></div>
          <button className="btn-primary" data-testid="contact-submit"><Send size={14}/> Send</button>
        </form>
      )}
      </div>
    </div>
  );
}
